import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_public-links/verification/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_public-links/verification/"!</div>
}
